<template>
  <div class="currency-select">
    <!-- <p class="text-xs my-24">網站提供AI翻譯的資訊。如翻譯內容有任何差異，請參考原文</p> -->
    <div class="flex flex-wrap w-full mt-16 text-sm font-medium">
      <li v-for="currency in this['user/currenciesList']" :key="currency.code"
        class="list-reset flex items-center justify-between mr-16 mb-8 p-8 cursor-pointer rounded-sm hover:bg-blue-lightest" style="width: calc((100% - 3rem)/3)"
        :class="currency.name === selectedCurrency && 'bg-blue-lightest'"
        @click="switchCurrency(currency.code)"
      >
        <div>
          <div>
            {{ currency.currency_name }}
          </div>
          <div>
            {{ currency.name }}
          </div>
        </div>
        <div v-if="currency.name === selectedCurrency">
          <i class="owl owl-status-check text-blue"></i>
        </div>
      </li>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'currencySelect',
  computed: {
    ...mapGetters({
      isDesktop: 'isDesktop',
      'user/currenciesList': 'user/currenciesList',
      selectedCurrency: 'user/selectedCurrency',
      'user/selectedCurrencyName': 'user/selectedCurrencyName'
    })
  },
  methods: {
    ...mapActions([
      'user/switchCurrency'
    ]),
    switchCurrency (currency) {
      this['user/switchCurrency'](currency)
      this.$modal.hide('currencySelect')
    }
  },
  watch: {
    isDesktop: {
      handler: function (newVal, oldVal) {
        if (!newVal) {
          this.$modal.hide('currencySelect')
        }
      }
    }
  }
}
</script>
<style lang="sass" scoped>
.currency-select
  @apply mx-24
  min-width: 350px
  .warning
</style>
